import React from "react";
import { Grid } from "@mui/material";

import Input from "../ReadOnlyInput";

import { formatUpperCase } from "../../../../utils/formats";

const LojistaSection = (props) => {
  const {
    proposalCompleteRegistrationLoading,
    nomeConvenio,
    nomeAgente,
    ratingFilial,
    nomeFilial,
    ufFilial,
    nomeFilialFantasia,
  } = props;

  return (
    <Grid container spacing={3}>
      <Grid item xs={4}>
        <Input
          loading={proposalCompleteRegistrationLoading}
          label="Convênio"
          value={formatUpperCase(nomeConvenio)}
        />
      </Grid>
      <Grid item xs={4}>
        <Input
          loading={proposalCompleteRegistrationLoading}
          label="Agente"
          value={formatUpperCase(nomeAgente)}
        />
      </Grid>
      <Grid item xs={4}>
        <Input
          loading={proposalCompleteRegistrationLoading}
          label="Rating (loja)"
          value={formatUpperCase(ratingFilial)}
        />
      </Grid>
      <Grid item xs={8}>
        <Input
          loading={proposalCompleteRegistrationLoading}
          label="Filial (loja)"
          value={formatUpperCase(nomeFilial)}
        />
      </Grid>
      <Grid item xs={4}>
        <Input
          loading={proposalCompleteRegistrationLoading}
          label="UF (loja)"
          value={formatUpperCase(ufFilial)}
        />
      </Grid>
      <Grid item xs={8}>
        <Input
          loading={proposalCompleteRegistrationLoading}
          label="Nome fantasia"
          value={formatUpperCase(nomeFilialFantasia)}
        />
      </Grid>
    </Grid>
  );
};

export default LojistaSection;
